<template>
  <v-data-table
    :headers="headers"
    :items="relatoriosTabela"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    class="elevation-0"
  >
    <!-- ordenar por e pesquisar -->
    <template v-slot:top>
      <v-row class="mb-2">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              {{ titulo }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>

      <!-- ordenar por -->
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>

        <v-col
          cols="0"
          md="4"
        />

        <!-- pesquisar -->
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <template v-slot:[`item.numero`]="{ index }">
      {{ index + 1 }}
    </template>

    <template v-slot:[`header.data-table-select`]>
      Nº
    </template>

    <template v-slot:[`item.autoavaliacao`]="{ item }">
      <v-icon
        v-if="item.autoavaliacao.icone != null"
        color="grey"
      >
        {{ item.autoavaliacao.icone }}
      </v-icon>
      <span v-else>Não há responsabilidades a serem avaliadas</span>
    </template>

    <template v-slot:[`item.avaliacaoGestor`]="{ item }">
      <v-icon
        v-if="item.avaliacaoGestor.icone != null"
        color="grey"
      >
        {{ item.avaliacaoGestor.icone }}
      </v-icon>
      <span v-else>NÃO SE APLICA</span>
    </template>

    <template v-slot:[`item.avaliacaoEquipe`]="{ item }">
      <v-icon
        v-if="item.avaliacaoEquipe.icone != null"
        color="grey"
      >
        {{ item.avaliacaoEquipe.icone }}
      </v-icon>
      <span v-else>NÃO SE APLICA</span>
    </template>

    <template v-slot:[`item.avaliacaoServidores`]="{ item }">
      <v-icon
        v-if="item.avaliacaoServidores.icone != null"
        color="grey"
      >
        {{ item.avaliacaoServidores.icone }}
      </v-icon>
      <span v-else>NÃO SE APLICA</span>
    </template>

    <template v-slot:[`item.avaliacaoGestores`]="{ item }">
      <v-icon
        v-if="item.avaliacaoGestores.icone != null"
        color="grey"
      >
        {{ item.avaliacaoGestores.icone }}
      </v-icon>
      <span v-else>NÃO SE APLICA</span>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaResultados',

  components: { AppSort, AppSearch },

  props: {
    relatorios: {
      type: Array,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    perspectiva: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'usuario.nome',
        selecionado: { id: 'usuario.nome', descricao: 'Servidor' },
        lista: [],
      },
    };
  },

  computed: {
    headers() {
      if (this.perspectiva === 'COMPORTAMENTAL') {
        return [
          {
            text: 'Nº',
            value: 'numero',
            width: '2%',
            sortable: false,
          },
          {
            text: 'SERVIDOR',
            value: 'usuario.nome',
            width: '15%',
            sortable: false,
          },
          {
            text: 'UNIDADE',
            value: 'unidade.sigla',
            width: '10%',
            align: 'center',
          },
          {
            text: 'CATEGORIA',
            value: 'usuario.categoria',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AUTOAVALIAÇÃO',
            value: 'autoavaliacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AVALIAÇÃO DO GESTOR',
            value: 'avaliacaoGestor',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AVALIAÇÃO DA EQUIPE',
            value: 'avaliacaoEquipe',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'SITUAÇÃO',
            value: 'situacao.descricao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
        ];
      }
      if (this.perspectiva === 'TECNICA') {
        return [
          {
            text: 'Nº',
            value: 'numero',
            width: '2%',
            sortable: false,
          },
          {
            text: 'SERVIDOR',
            value: 'usuario.nome',
            width: '15%',
            sortable: false,
          },
          {
            text: 'UNIDADE',
            value: 'unidade.sigla',
            width: '10%',
            align: 'center',
          },
          {
            text: 'CATEGORIA',
            value: 'usuario.categoria',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AUTOAVALIAÇÃO',
            value: 'autoavaliacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AVALIAÇÃO DA EQUIPE DE SERVIDORES',
            value: 'avaliacaoServidores',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AVALIAÇÃO DA EQUIPE DE GESTORES',
            value: 'avaliacaoGestores',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'SITUAÇÃO',
            value: 'situacaoTecnico.descricao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
        ];
      }
      return [];
    },
    relatoriosTabela() {
      if (this.perspectiva === 'COMPORTAMENTAL') {
        return _.flatMap(this.relatorios, (r) => r.servidores
          .filter((s) => !s.foiDispensado)
          .map((s) => ({
            ...s,
            ...r,
            autoavaliacao: {
              icone: this.checkBoxIcon(s.fezAutoavaliacao),
              ordenacao: s.fezAutoavaliacao ? 1 : 2, // TRUE = 1, FALSE = 2, NULL = 3
            },
            avaliacaoGestor:
                s.fezAvaliacaoGestor !== null
                  ? { icone: this.checkBoxIcon(s.fezAvaliacaoGestor), ordenacao: s.fezAvaliacaoGestor ? 1 : 2 }
                  : { icone: null, ordenacao: 3 },
            avaliacaoEquipe:
                s.avaliaGestores || s.avaliaServidores || s.avaliaPares
                  ? { icone: this.checkBoxIcon(s.fezAvaliacaoEquipe), ordenacao: s.fezAvaliacaoEquipe ? 1 : 2 }
                  : { icone: null, ordenacao: 3 },
          })));
      }
      if (this.perspectiva === 'TECNICA') {
        return _.flatMap(this.relatorios, (r) => r.servidores
          .filter((s) => !s.foiDispensado)
          .map((s) => ({
            ...s,
            ...r,
            autoavaliacao: s.temResponsabilidadeASerAvaliado
              ? {
                icone: this.checkBoxIcon(s.fezAutoavaliacaoTecnica),
                ordenacao: s.fezAutoavaliacaoTecnica ? 1 : 2, // TRUE = 1, FALSE = 2, NULL = 3
              }
              : { icone: null, ordenacao: 3 },
            avaliacaoServidores: s.avaliaServidoresTecnico
              ? {
                icone: this.checkBoxIcon(s.fezAvaliacaoTecnicaEquipeServidores),
                ordenacao: s.fezAvaliacaoTecnicaEquipeServidores ? 1 : 2,
              }
              : { icone: null, ordenacao: 3 },
            avaliacaoGestores: s.avaliaGestores
              ? {
                icone: this.checkBoxIcon(s.fezAvaliacaoTecnicaEquipeGestores),
                ordenacao: s.fezAvaliacaoTecnicaEquipeGestores ? 1 : 2,
              }
              : { icone: null, ordenacao: 3 },
          })));
      }
      return [];
    },
  },
  created() {
    if (this.perspectiva === 'COMPORTAMENTAL') {
      this.opcoes.lista = [
        { id: 'usuario.nome', descricao: 'Servidor' },
        { id: 'unidade.sigla', descricao: 'Sigla da Unidade' },
        { id: 'usuario.categoria', descricao: 'Categoria' },
        { id: 'autoavaliacao.ordenacao', descricao: 'Autoavaliação' },
        { id: 'avaliacaoGestor.ordenacao', descricao: 'Avaliação do Gestor' },
        { id: 'avaliacaoEquipe.ordenacao', descricao: 'Avaliação da Equipe' },
        { id: 'situacao.id', descricao: 'Situação' },
      ];
    } else if (this.perspectiva === 'TECNICA') {
      this.opcoes.lista = [
        { id: 'usuario.nome', descricao: 'Servidor' },
        { id: 'unidade.sigla', descricao: 'Sigla da Unidade' },
        { id: 'usuario.categoria', descricao: 'Categoria' },
        { id: 'autoavaliacao.ordenacao', descricao: 'Autoavaliação' },
        { id: 'avaliacaoServidores.ordenacao', descricao: 'Avaliação da Equipe de Servidores' },
        { id: 'avaliacaoGestores.ordenacao', descricao: 'Avaliação da Equipe de Gestores' },
        { id: 'situacaoTecnico.id', descricao: 'Situação' },
      ];
    } else {
      this.opcoes.lista = [];
    }
  },

  methods: {
    checkBoxIcon(isChecked) {
      return isChecked ? 'check_box' : 'check_box_outline_blank';
    },
  },
};
</script>
